// extracted by mini-css-extract-plugin
export default {"table":"styles_table__3ut9t","borderHorizontal":"styles_borderHorizontal__IBA6t","borderVertical":"styles_borderVertical__1aHTT"};